<div class="w-full h-full flex flex-column border-round-xl shadow-2" [style]="{background: 'var(--p-content-background)'}">
    <!-- Header -->
    <div class="flex justify-content-between align-items-center p-3  border-bottom-1 border-300">
        <h4 class="text-lg font-bold text-900 m-0">Contracts</h4>
        <button
            type="button"
            class="bg-transparent border-none cursor-pointer p-2 flex align-items-center justify-content-center text-500 transition-colors transition-duration-200 hover:text-900"
            (click)="onClose()"
            aria-label="Close panel">
            <i class="pi pi-times text-xl"></i>
        </button>
    </div>

    <!-- Contracts List -->
    <div class="flex-1 overflow-y-auto p-3" style="max-height: calc(100vh - 200px);">
            <div
                class="border-1 border-300 border-round mb-3 bg-white overflow-hidden"
                *ngFor="let contract of contracts; let last = last"
                [class.mb-0]="last">
                
                <!-- Contract Header -->
                <div class="flex justify-content-between p-3 bg-gray-50 border-bottom-1 border-300">
                    <div class="font-bold text-base text-900">{{ contract.type }}</div>
                    <div class="flex align-items-center gap-2 font-semibold text-900">
                        <i class="pi pi-file"></i>
                        <span>{{ contract.identifier }}</span>
                    </div>
                </div>

                <!-- Contract Details -->
                <div class="p-3">
                    <!-- Status -->
                    <div class="flex justify-content-between align-items-center py-2 text-sm border-bottom-1 border-200">
                        <span>Status</span>
                        <span class="status-tag font-bold px-2 py-1 border-round text-xs" [ngClass]="getContractBadgeClass(contract)">
                            {{ getContractBadge(contract) }}
                        </span>
                    </div>

                    <!-- Partner -->
                    <div class="flex justify-content-between align-items-center py-2 text-sm border-bottom-1 border-200">
                        <span>{{ contract.partner }}</span>
                        <span class="font-bold text-900">
                            {{ getContractMonthlyPrice(contract) | number:'1.2-2' }} €
                        </span>
                    </div>

                    <!-- WIK Date -->
                    <div class="flex justify-content-between align-items-center py-2 text-sm">
                        <span>{{ contract.status === 'new' ? 'Startdatum' : 'WIK zum' }}</span>
                        <div class="flex align-items-center gap-2 font-semibold">
                            <i
                                class="pi"
                                [ngClass]="{
                                    'pi-shield text-green-600': contract.status === 'reactivated',
                                    'pi-exclamation-circle text-red-500': contract.status === 'cancelled',
                                    'pi-file text-gray-400': contract.status === 'new'
                                }"
                            ></i>
                            <span [ngClass]="{ 'line-through text-color-secondary': contract.status === 'cancelled' }">
                                {{ getWikDate(contract) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


